var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SaleForm',{attrs:{"operation":_vm.operation,"movement_stock":"1","movement_stock_type":"in","movement_finance":"1","movement_finance_type":"in","id":this.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }